export default "__VITE_ASSET__b12da96d__"